import { Box, styled } from '@mui/material';

export const StyledWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;

  &:hover {
    cursor: pointer;
  }
`;
